export default __webpack_public_path__ + "static/media/lodgify_step9.b5ae998e.jpg";